<div
  class="vi-icon"
  data-at-icon
  [ngStyle]="{ width: getSize(), height: getSize() }"
>
  <img [src]="getIconUrl()" />
</div>
